import React from 'react';
import styles from './BrokerWiseBrokerLogo.module.scss';
import { brokerWiseAppBrokerList } from '../../../data/broker-wise-app-broker-list';
import { moduleBrokerName } from '../../../module-params';

function useBrokerLogo() {
  const targetBrokerLogo =
    moduleBrokerName &&
    brokerWiseAppBrokerList.find((item) => item.name === moduleBrokerName);

  return targetBrokerLogo || {};
}

const BrokerWiseBrokerLogo = () => {
  const { name, logo } = useBrokerLogo();

  if (!logo) {
    return <></>;
  }

  return (
    <div className={styles.BrokerWiseBrokerLogo}>
      <span className={styles.separator}>/</span>
      <img src={logo} alt={name} />
    </div>
  );
};

export default BrokerWiseBrokerLogo;
